module.exports = __webpack_public_path__ + "img/img_inner_camouflage.0d94d04f.png";